import home from '~/assets/icons/home.svg';
import { playSound, Sound } from '~/assets/sounds';

import { StyledContainer, StyledTextLabel } from './HouseButton.styled';

interface IHouseButtonProps extends React.HTMLAttributes<HTMLDivElement> {
	text: string;
	icon?: string;
	onClick?: () => void;
	active?: boolean;
}

const HouseButton: React.FC<IHouseButtonProps> = ({
	text,
	icon,
	onClick,
	active,
}: IHouseButtonProps) => {
	return (
		<StyledContainer
			onClick={() => {
				onClick?.();
				playSound(Sound.ClickButton);
			}}
			$active={active}
			onMouseEnter={() => playSound(Sound.LinkCursor)}
		>
			<StyledTextLabel>{text}</StyledTextLabel>
			<img src={icon || home} />
		</StyledContainer>
	);
};

export { HouseButton };
